import React, {Component} from 'react';
import lang from '../lang/index';
import VideoPlay from '../videoplay/index';
import env from 'c-nenv';
import WechatShare from 'c-up-wechatshare';
import Title from 'c-title';
import global from '../base/global';

class VideoTypeView extends Component {
    static defaultProps = {
        data: {}
    }
    constructor(props) {
        super(props);
        
        this.state = {
            gotHostInfo: false,
            playedEnd: false,
            androidWechatFullScreen: 0 // android wechat是否全屏
        };

        let { content, dynamicShareInfo} = props.data;

        let userInfo = content.videoSourceUserInfo;

        this.hostInfo = {
            hostid: longToString(userInfo.uid),
            videoUrl: content.resourceUrls[0].replace('http:','https:'),
            coverUrl: content.coverUrl,
            title: dynamicShareInfo.title,
            username: userInfo.userName,
            resourceDesp: content.resourceDesp
        };
    }

    componentWillMount(){
        let title = this.hostInfo.title;
        let img = this.hostInfo.coverUrl;

        if (title) {
            Title.set(title);
        }

        if (env.platform.isWeixin) {
            let wechatShare = new WechatShare();

            wechatShare.set({
                title: title,
                link: location.href,
                imgUrl: img,
                desc: title
            });
        }
    }

    componentDidMount(){
        $.channel.on('livingEnd', ()=>{
            this.setState({
                playedEnd: true
            });
        });
        $.channel.on('livingPause', ()=>{
            this.setState({
                playedEnd: false
            });
        });
    }

    onPlayStart=()=>{
        this.setState({
            playedEnd: false
        });
    }

    onGetHostInfo = ()=>{
        this.setState({
            gotHostInfo: true
        });
    }

    h5uplive=(e)=>{
        global.goUpliveHome();
    }

    download=(e)=>{
        $.channel.emit('download');
        $.channel.emit('videopause');
    }

    profile=(e)=>{
        global.goUpliveProfile(this.hostInfo.hostid);
    }


    onAndroidWechatEnterFullScreen = ()=>{
        setTimeout(()=>{
            this.setState({
                androidWechatFullScreen: 1
            });
        }, 300);
    };

    onAndroidWechatExitFullScreen = ()=>{
        setTimeout(()=>{
            this.setState({
                androidWechatFullScreen: 0
            });
        }, 300);
    };

    render() {
        return (
            <div className="content-wrapper">
            	<i className="type">{lang.template('视频')}</i>
                <div className="player-wrapper" ref="wrapper" style={{height: document.documentElement.clientHeight + 'px'}}>
                    <VideoPlay 
                        key={this.state.hostid}
                        {...this.hostInfo}
                        onPlayStart={this.onPlayStart}
                        onGetHostInfo={this.onGetHostInfo}
                        onAndroidWechatEnterFullScreen={this.onAndroidWechatEnterFullScreen}
                        onAndroidWechatExitFullScreen={this.onAndroidWechatExitFullScreen}
                    />
                    <div className="btns">
                        { this.state.playedEnd ? <div className="btn" onClick={this.h5uplive}>{lang.template('去查看其他精彩直播')}</div> : null }
                        <div className="btn" onClick={this.download}>{ lang.template('打开Up直播，直播全世界') }</div>
                    </div>
                </div>
                {  
                	this.hostInfo.username ? 
                	(
                		<div className="host-wrapper" >
		                    <label>{lang.template('录制的小视频来自')} : </label>
		                    <span  onClick={this.profile} dangerouslySetInnerHTML = {{__html: lang.template('<%=name%>的直播', {name: this.hostInfo.username}, 1)}}></span>
		                </div>
					) : null
                }
            </div>
        );
        
    }
}

export default VideoTypeView;


// WEBPACK FOOTER //
// ./js/feedshare/video.js